export default {
	"contactUs": {
		"title": "FCA 계좌를 개설하면 가장 권위 있는 규제 보호와 가장 안전한 금융 보호를 받을 수 있습니다. 지금 개설하십시오.",
		"title1": "거래를 열심히 하는 사람은 모두 열심을 다한 대우를 받을 가치가 있다.",
		"code": "확인 코드",
	},
	"dividend": {
		"title": "CFD 배당금",
		"title1": "CFD 배당금 :",
		"desc": "* 알림: CFD 배당금은 입출금 형식으로 MT4 계정 잔액에 반영되며 “주식 배당금” 으로 기록됩니다.",
		"btn": "투자 시작"
	},
	"notice": "EBC 그룹은 우리사의 명칭이 온라인 암호 화폐를 제공하는 EBankcD라는 화시와 연관하였다고는 것을 알았습니다. <br/><br/>우리는 이에 대해 설명하고 싶습니다.  EBC그룹의 공식 웹사이트는 www.ebc.com와 www.ebcfin.com 이며, 두 사이트에서 그룹이 제공하는 제품 및  업무 서비스를  자세히 소개하고 있습니다. 그리고 암호화폐는 이 중의 하나가 아닙니다. <br/><br/>또 EBC금융그룹 유한회사는 www.ebcfin.co.uk 공식 웹사이트만 있고 이 사이트에서 우리가 제공하는 모든 제품을 자세히 기록하고 있으며 암호화폐가 그 중에 없다고 명확하게 말하고 싶습니다. <br/><br/>EBC그룹 명의 모든 회사는 사법 관할구역의 규정에 따라 운영되며 제3자가 승인되지 않은 프로젝트에서 회사의 브랜드 사용을 저지하기 위해 필요한 모든 조치를 취할 것입니다. ",
	"contact": {
		"title": "여기에서 투자가 시작됩니다.",
		"pageTitle": "계좌 개설 상담",
		"pageEnTitle": "Inquiry",
		"name": "성 ｜ 직함",
		"sexList": [{
			"label": "남성",
			"value": "sir"
		}, {
			"label": "여자",
			"value": "lady"
		}],
		"email": "연락처 전화 또는 이메일",
		"btn": "연락처 요청 보내기",
		"tips1": "당신 의 호칭 을 입력 하 세 요!",
		"tips2": "당신 의 연락 처 를 입력 하 세 요!",
		"tips3": "댓 글 성공!",
		"tips4": "정확 한 인증 번 호 를 입력 하 십시오!"
	},
	"column1": {
		"placeholder": "사이트 검색",
		"login": "로그인",
		"langText": "EBC 사이트 지역/언어",
		"langList": [{
			"text": "简中",
			"value": "zh_CN"
		}, {
			"text": "English",
			"value": "en_US"
		}, {
			"text": "繁體",
			"value": "zh_TW"
		}, {
			"text": "日本語",
			"value": "ja_JP"
		}, {
			"text": "ئۇيغۇر تىلى",
			"value": "weiwuer"
		}]
	},
	"linkList": [{
		"title": "계정 및 조건",
		"list": [{
				"label": "거래 계정",
				"link": "/TradingAccount"
			},{
				"label": "거래 제품",
				"link": "/tradingproduct"
			},{
				"label": "레버리지 마진",
				"link": "/leverage-margin"
			},
			{
				"label": "입출금",
				"link": "/funding"
			},
			{
				"label": "피제수",
				"link": "/dividend"
			}
		]
	},{
		"title": "트레이딩 도구",
		"list": [{
				"label": "MT4 다운로드",
				"link": "/MT4"
			},{
				"label": "MT5 다운로드",
				"link": "/MT5"
			},{
				"label": "MT4 거래 도구",
				"link": "/tools"
			}, {
				"label": "PAMM",
				"link": "/PAMM"
			},{
				"label": "마케팅 분석",
				"link": "/market-analysis"
				
			}
		]
	},{
		"title": "EBC 연구원",
		"list": [{
				"label": "교육 중심",
				"link": "/LearningCenter"
			}, {
				"label": "데이터 중심",
				"link": "/lab"
			}
		]
	}, {
		"title": "최신 이벤트",
		"list": [{
			"label": "트레이딩 대회",
			"link": "/win"
		},{
			"label": "거래 급여 프로그램",
			"link": "/pay"
		},
		// {
		// 	"label": "최강의 거래 환경을 시작해보세요",
		// 	"link": "/no1"
		// }
	]
	}, {
		"title": "협력 모드",
		"list": [{
			"label": "임팩트 얼라이언스",
			"link": "/affiliate-programmes"
		},{
			"label": "기관 서비스",
			"link": "/service"
		},{
			"label": "기반 기술",
			"link": "/technology"
		}]
	}, {
		"title": "EBC 소개",
		"list": [{
			"label": "WHY EBC",
			"link": "/about-us"
		},  {
			"label": "법률 문서",
			"link": "/LegalDocumen"
		}, {
			"label": "Sustainability & Impact",
			"link": "/ESG"
		}, {
			"label": "FAQ",
			"link": "/FAQ"
		},{
			"label": "공식 채널 인증",
			"link": "/official-verification"
		}]
	}],
	"headlist": [{
		"text": "홈페이지",
		"url": "/"
	}, {
		"text": "거래",
		"menu": [{
			"text": "거래상품",
			"url": "/tradingproduct"
		}, {
			"text": "거래 계좌",
			"url": "/TradingAccount"
		}, {
			"text": "거래 조건",
			"menu": [{
				"text": "출입금",
				"url": "/funding"
			}, {
				"text": "레버리지 및 보증금",
				"url": "/leverage-margin"
			}]
		}, {
			"text": "거래 플랫폼",
			"menu": [{
				"text": "MT4",
				"url": "/MT4"
			}, {
				"text": "MAM",
				"url": "/MAM"
			}]
		}, {
			"text": "배당금",
			"url": "/dividend"
		}]
	}, {
		"text": "LAB 및 도구",
		"menu": [{
			"text": "학습 센터",
			"url": "/LearningCenter"
		}, {
			"text": "데이터 센터",
			"url": "/lab"
		}]
	}, {
		"text": "기관 협력",
		"menu": [{
			"text": "기본 기술",
			"url": "/technology"
		}, {
			"text": "기구서비스",
			"url": "/service"
		}, {
			"text": "파트너",
			"url": "/partner"
		}]
	}, {
		"text": "EBC 정보",
		"menu": [{
			"text": "EBC 소개",
			"url": "/about-us"
		}, {
			"text": "FAQ",
			"url": "/FAQ"
		}]
	}, {
		"text": "교역대회",
		"url": "/win"
	}, {
		"text": "로그인",
		"url": "https://client.myebc.co/signup/?bid=5s71xp"
	}],
	"login": "계좌 개설",
	"zhuce": "로그인",
	"gendan": "주문 커뮤니티",
	"pdfLang": "en",
	"bannerLang":"ko",
	"language":"한 국 어",
	"className": "ko-box",
	"text": "EBC Financial Group은 다음 회사들이 함께 사용하는 공동 브랜드입니다:<br>\"EBC Financial Group (SVG) LLC\"는 세인트빈센트 그레나딘즈 금융 서비스 관리국에서 승인 및 감독을 받았으며, 등록 번호는 353 LLC 2020입니다.<br>관련 엔터티<br>\"EBC Financial Group (UK) Limited\"는 영국 금융행동감독청(Financial Conduct Authority, FCA)의 승인과 감독을 받았으며,  규제 번호는 927552입니다.웹사이트 : <a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcfin.co.uk\" rel=\"nofollow\">www.ebcfin.co.uk</a><br>EBC Financial group (Australia) Pty Ltd (회사번호:619 073 237)는 오스트랄리아 증권 투자 위원회가 승인 및 감독하고 있습니다. (규제번호:500991).EBC Financial Group (Australia) Pty Ltd 는 EBC Financial Group (SVG) LLC의 관련 실체이며 두 실체 모두 독립으로 운영 관리하고 있습니다. 본 사이트가 제공하는 금융상품과 서비스는 오스트랄리아회사 실체에서 제공하는 것이 아니며, 오스트랄리아실체의 책임 와는 관련되지 않습니다.<br>EBC Financial Group (Cayman) Limited는 케이맨 제도 통화청(번호: 2038223)의 허가를 받고 규제를 받습니다. 웹사이트: <a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcgroup.ky\" rel=\"nofollow\">www.ebcgroup.ky</a><br>회사 주소: The Leadenhall Building, 122 Leadenhall Street, London, United Kingdom, EC3V 4AB이메일 주소: cs@ebc.com전화번호: +44 20 3376 9662<br>면책 조항: EBC 금융 그룹은 어떠한 암호화폐 활동에 참여하지 않으며 차익결제거래 (CFD)를 제공하지 않습니다. 저희의 금융 서비스는 전통적인 금융 상품에 한정되어 있습니다. EBC 이름을 사용한 암호화폐 관련 서비스에 대한 어떠한 언급도 정확하지 않으며, 이는 비인가된 것임을 고객님들에게 알려드립니다.과거의 성과는 미래의 성과를 보증하지 않으며, 웹사이트에 포함된 내용은 참고용으로만 제공되며 어떠한 투자 조언도 제공하지 않습니다.<br>지역 제한:EBC는 다음과 같은 특정 관할권의 시민 및 거주자에게는 서비스를 제공하지 않습니다: 아프가니스탄, 벨라루스, 버마(미얀마), 캐나다, 중앙아프리카공화국, 콩고, 쿠바, 콩고민주공화국, 에리트레아, 아이티, 이란, 이라크, 레바논, 리비아, 말레이시아, 말리, 북한(조선민주주의인민공화국), 러시아, 소말리아, 수단, 남수단, 시리아, 우크라이나(크림, 도네츠크 및 루한스크 지역 포함), 미국, 베네수엘라 및 예멘입니다. 자세한 내용은 자주 묻는 질문을 참조하세요.<br>법적 준수 공지:회사 웹사이트는 전세계에서 접근 가능하며 어떠한 특정 엔터티를 대상으로 하지 않습니다. 귀하의 권리와 책임은 귀하가 선택한 지역의 규제 및 엔터티에 따라 결정됩니다. 현지 법률 및 규제는 웹사이트에 게시된 모든 문서와 정보에 대한 접근, 다운로드, 전파, 공유 또는 사용을 금지하거나 제한할 수 있습니다.<br>리스크 경고: 차액결제거래(CFD)는 복잡한 금융 상품으로 높은 레버리지로 인해 신속하게 자금을 잃을 수 있는 고위험 수준을 가지고 있습니다. 마진 거래는 높은 수준의 리스크를 내포하며 모든 투자자에게 적합하지 않을 수 있습니다. 외환 및 CFD 거래를 결정하기 전에 거래 목표, 경험 수준 및 리스크 선호도를 신중하게 고려해야 합니다. 초기 거래 자본의 일부 또는 전부를 잃을 수 있는 가능성이 있습니다. 독립적인 자문을 받고 어떠한 투자 결정을 내리기 전에 관련된 리스크를 완전히 이해하도록 권장합니다. 거래를 시작하기 전에 관련된 리스크 공개 성명을 주의 깊게 읽어보시기 바랍니다.",
	"waptext": "EBC Financial Group은 다음 회사들이 함께 사용하는 공동 브랜드입니다:<br>\"EBC Financial Group (SVG) LLC\"는 세인트빈센트 그레나딘즈 금융 서비스 관리국에서 승인 및 감독을 받았으며, 등록 번호는 353 LLC 2020입니다.<br>관련 엔터티<br>\"EBC Financial Group (UK) Limited\"는 영국 금융행동감독청(Financial Conduct Authority, FCA)의 승인과 감독을 받았으며,  규제 번호는 927552입니다.웹사이트 : <a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcfin.co.uk\" rel=\"nofollow\">www.ebcfin.co.uk</a><br>EBC Financial group (Australia) Pty Ltd (회사번호:619 073 237)는 오스트랄리아 증권 투자 위원회가 승인 및 감독하고 있습니다. (규제번호:500991).EBC Financial Group (Australia) Pty Ltd 는 EBC Financial Group (SVG) LLC의 관련 실체이며 두 실체 모두 독립으로 운영 관리하고 있습니다. 본 사이트가 제공하는 금융상품과 서비스는 오스트랄리아회사 실체에서 제공하는 것이 아니며, 오스트랄리아실체의 책임 와는 관련되지 않습니다.<br>EBC Financial Group (Cayman) Limited는 케이맨 제도 통화청(번호: 2038223)의 허가를 받고 규제를 받습니다. 웹사이트: <a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcgroup.ky\" rel=\"nofollow\">www.ebcgroup.ky</a><br>회사 주소: The Leadenhall Building, 122 Leadenhall Street, London, United Kingdom, EC3V 4AB이메일 주소: cs@ebc.com전화번호: +44 20 3376 9662<br>면책 조항: EBC 금융 그룹은 어떠한 암호화폐 활동에 참여하지 않으며 차익결제거래 (CFD)를 제공하지 않습니다. 저희의 금융 서비스는 전통적인 금융 상품에 한정되어 있습니다. EBC 이름을 사용한 암호화폐 관련 서비스에 대한 어떠한 언급도 정확하지 않으며, 이는 비인가된 것임을 고객님들에게 알려드립니다.과거의 성과는 미래의 성과를 보증하지 않으며, 웹사이트에 포함된 내용은 참고용으로만 제공되며 어떠한 투자 조언도 제공하지 않습니다.<br>지역 제한:EBC는 다음과 같은 특정 관할권의 시민 및 거주자에게는 서비스를 제공하지 않습니다: 아프가니스탄, 벨라루스, 버마(미얀마), 캐나다, 중앙아프리카공화국, 콩고, 쿠바, 콩고민주공화국, 에리트레아, 아이티, 이란, 이라크, 레바논, 리비아, 말레이시아, 말리, 북한(조선민주주의인민공화국), 러시아, 소말리아, 수단, 남수단, 시리아, 우크라이나(크림, 도네츠크 및 루한스크 지역 포함), 미국, 베네수엘라 및 예멘입니다. 자세한 내용은 자주 묻는 질문을 참조하세요.<br>법적 준수 공지:회사 웹사이트는 전세계에서 접근 가능하며 어떠한 특정 엔터티를 대상으로 하지 않습니다. 귀하의 권리와 책임은 귀하가 선택한 지역의 규제 및 엔터티에 따라 결정됩니다. 현지 법률 및 규제는 웹사이트에 게시된 모든 문서와 정보에 대한 접근, 다운로드, 전파, 공유 또는 사용을 금지하거나 제한할 수 있습니다.<br>리스크 경고: 차액결제거래(CFD)는 복잡한 금융 상품으로 높은 레버리지로 인해 신속하게 자금을 잃을 수 있는 고위험 수준을 가지고 있습니다. 마진 거래는 높은 수준의 리스크를 내포하며 모든 투자자에게 적합하지 않을 수 있습니다. 외환 및 CFD 거래를 결정하기 전에 거래 목표, 경험 수준 및 리스크 선호도를 신중하게 고려해야 합니다. 초기 거래 자본의 일부 또는 전부를 잃을 수 있는 가능성이 있습니다. 독립적인 자문을 받고 어떠한 투자 결정을 내리기 전에 관련된 리스크를 완전히 이해하도록 권장합니다. 거래를 시작하기 전에 관련된 리스크 공개 성명을 주의 깊게 읽어보시기 바랍니다."
}

